var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 4,
    fill: "#FFEACC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.79 10.2203C22.83 7.27031 18.03 7.27031 15.09 10.2203C13.02 12.2703 12.4 15.2203 13.2 17.8203L8.50002 22.5203C8.17002 22.8603 7.94002 23.5303 8.01002 24.0103L8.31002 26.1903C8.42002 26.9103 9.09002 27.5903 9.81002 27.6903L11.99 27.9903C12.47 28.0603 13.14 27.8403 13.48 27.4903L14.3 26.6703C14.5 26.4803 14.5 26.1603 14.3 25.9603L12.36 24.0203C12.07 23.7303 12.07 23.2503 12.36 22.9603C12.65 22.6703 13.13 22.6703 13.42 22.9603L15.37 24.9103C15.56 25.1003 15.88 25.1003 16.07 24.9103L18.19 22.8003C20.78 23.6103 23.73 22.9803 25.79 20.9303C28.74 17.9803 28.74 13.1703 25.79 10.2203ZM20.5 18.0003C19.12 18.0003 18 16.8803 18 15.5003C18 14.1203 19.12 13.0003 20.5 13.0003C21.88 13.0003 23 14.1203 23 15.5003C23 16.8803 21.88 18.0003 20.5 18.0003Z",
    fill: "#FF671E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingPassword);
export default __webpack_public_path__ + "static/media/setting-password.45b9ba51f69483d4cdd6145fb4d295ef.svg";
export { ForwardRef as ReactComponent };